export default __webpack_public_path__ + "static/media/learning.be70dac8.svg";